import React, { useState } from "react";
import axios from "axios";
import { Modal, Button, Form, Icon } from "semantic-ui-react";

const OrderUpload = ({ open, onClose }) => {
    const [file, setFile] = useState(null);
    const [uploading, setUploading] = useState(false);

    const handleFileChange = (e) => {
        if (e.target.files.length > 0) {
            setFile(e.target.files[0]);
        }
    };

    const handleUpload = async () => {
        if (!file) {
            alert("Please select an XML file.");
            return;
        }

        const jwttoken = localStorage.getItem("binfra_token");

        const formData = new FormData();
        formData.append("file", file);

        setUploading(true);

        try {
            const response = await axios.post(
                "https://dev-nishal.api.bpo-projekt.de/api/pre-projects/upload?v=6",
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${jwttoken}`,
                    },
                }
            );

            alert(
                `Successfully imported ${response.data.data.imported} project(s)!`
            );

            setFile(null);
            onClose();
        } catch (error) {
            console.error(error);

            if (error.response?.data?.message) {
                alert(error.response.data.message);
            } else {
                alert("Upload failed.");
            }
        } finally {
            setUploading(false);
        }
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            closeOnDimmerClick={false}
            size="small"
        >
            <Modal.Header>Upload XML Orders</Modal.Header>

            <Modal.Content>
                <Form>
                    <Form.Field>
                        <label>Select XML File</label>

                        <input
                            type="file"
                            accept=".xml,text/xml"
                            onChange={handleFileChange}
                        />
                    </Form.Field>

                    {file && (
                        <p>
                            <Icon name="file code" />
                            <strong>{file.name}</strong>
                        </p>
                    )}
                </Form>
            </Modal.Content>

            <Modal.Actions>
                <Button
                    onClick={() => {
                        setFile(null);
                        onClose();
                    }}
                    disabled={uploading}
                >
                    Cancel
                </Button>

                <Button
                    primary
                    icon="upload"
                    content={uploading ? "Uploading..." : "Upload"}
                    loading={uploading}
                    disabled={!file || uploading}
                    onClick={handleUpload}
                />
            </Modal.Actions>
        </Modal>
    );
};

export default OrderUpload;